<template>
    <span>
        <b-button-group class="float-right">
            <b-button
                variant="primary"
                @click="fluxoNovoPagamento()"
                v-if="temAcessoInserir"
                ><i class="fa fa-plus"></i> Novo Registro de Pagamento</b-button
            >
        </b-button-group>
        <b-modal 
            v-model="mostrarModal" 
            size="lg"
        >
            <div slot="modal-title">
                Novo Registro de Pagamento - Selecione o fornecedor
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12" md="9" v-if="!fornecedorExterno">
                    <b-form-group >
                        <label class="required" >CPF/CNPJ Formecedor</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                maxlength="18"
                                placeholder="Digite o CPF ou CNPJ do fornecedor"
                                v-model="fornecedorCPFCNPJ"
                                
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                    variant="primary"
                                    @click="pesquisarFornecedor()"
                                    title="Clique para pesquisar o fornecedor"
                                >
                                    <i class="fa fa-search"></i>
                                </b-button>
                            </b-input-group-append>
                            <b-form-invalid-feedback>
                                O CPF ou CNPJ do fornecedor é obrigatório
                            </b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="9" v-if="fornecedorExterno">
                    <b-form-group >
                        <label class="required" >Código Formecedor</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                maxlength="8"
                                placeholder="Digite o Código do fornecedor"
                                v-model="fornecedorCodCfo"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                    variant="primary"
                                    @click="pesquisarFornecedor()"
                                    title="Clique para pesquisar o fornecedor"
                                >
                                    <i class="fa fa-search"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md=3>
                    <b-form-group>
                        <label>
                        </label>
                        <b-checkbox
                            v-model="fornecedorExterno"
                        >
                            Fornecedor Estrangeiro
                        </b-checkbox>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="12" >
                    <b-form-group>
                        <label for="razaoSocial">Razão social</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                id="razaoSocial"
                                v-model="fornecedor.nome"
                                :disabled="true"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarNovoPagamento()"
                    class="ml-2"
                >
                    <span> <i class="fa fa-check-circle"></i> Selecionar</span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { ModelListSelect } from 'vue-search-select'

export default {
    props: {
        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        temAcessoInserir: {
            type: Boolean,
            default: () => false
        },

        escolherFornecedor: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            fornecedorCPFCNPJ: null,
            fornecedor: {},
            fornecedorCodCfo: null,
            fornecedorExterno: false,
        }
    },

    methods: {
        fluxoNovoPagamento() {
            if (this.escolherFornecedor) {
                this.abrirModal()
            } else {
                this.confirmarNovoPagamento()
            }
        },

        inserirPagamento() {
            this.$store.dispatch('addRequest')
            let criacaoPagamento = null;
            if (this.escolherFornecedor) {
                let inserirPagamentoForm = {
                    fornecedorCNPJ: this.fornecedorExterno ? this.fornecedorCodCfo : this.fornecedorCPFCNPJ.apenasNumeros(),
                    fornecedorExterno: this.fornecedorExterno,
                    codCfo: this.fornecedorCodCfo
                }
                criacaoPagamento = this.pagamentosServicos.inserirPagamento(inserirPagamentoForm)
            } else {
                criacaoPagamento = this.pagamentosServicos.inserirPagamento()
            }

            criacaoPagamento.then(response => {
                if (response) {
                    if (response.success) {
                        let pagamentoId = response.data
                        this.$store.dispatch('setRecarregar', true)
                        this.$emit('detalharPagamento', pagamentoId)
                        this.fecharModal()
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarNovoPagamento() {
            this.$swal({
                title: 'Novo Pagamento',
                html: `Confirma a criação de um novo protocolo de pagamento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.inserirPagamento()
                }
            })
        },

        abrirModal() {
            this.fornecedorCPFCNPJ = null
            this.fornecedorCodCfo = null
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.fornecedor = {}
        },

        pesquisarFornecedor() {
            var referencia = this.fornecedorExterno ? this.fornecedorCodCfo : this.fornecedorCPFCNPJ;
            if(!/[a-zA-Z]/.test(referencia) && referencia.length > 0)
            {
                this.$store.dispatch("addRequest")
                this.pagamentosServicos.obterFornecedor(this.fornecedorExterno ? this.fornecedorCodCfo : this.fornecedorCPFCNPJ.apenasNumeros()).then(response => {
                    if (response) {
                        if (response.success) {
                            this.fornecedor = response.data
                        } else {
                            this.$toast.error(
                                "Não foi possivel obter o fornecedor",
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch("removeRequest")
                })
            }
        },

    formatCPFCNPJ() {
        let onlyNumbers = this.fornecedorCPFCNPJ.replace(/\D/g, "");
        if (onlyNumbers.length <= 11) {
            this.fornecedorCPFCNPJ = this.formatCPF(onlyNumbers);
        } else if (onlyNumbers.length > 11 && onlyNumbers.length < 14) {
            this.fornecedorCPFCNPJ = onlyNumbers;
        } else if (onlyNumbers.length === 14) {
            this.fornecedorCPFCNPJ = this.formatCNPJ(onlyNumbers);
        }
    },
    formatCPF(value) {
        return value
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        },

    formatCNPJ(value) {
        return value
            .replace(/^(\d{2})(\d)/, "$1.$2")
            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
            .replace(/\.(\d{3})(\d)/, ".$1/$2")
            .replace(/(\d{4})(\d)/, "$1-$2");
        },
    },

    watch: {
        fornecedorExterno()
        {
            this.fornecedorCPFCNPJ = '';
            this.fornecedorCodCfo = '';
        },
        
        fornecedorCPFCNPJ() {
            if(this.fornecedorCPFCNPJ != null && this.fornecedorCPFCNPJ.length > 0)
            {
                let onlyNumbers = this.fornecedorCPFCNPJ.replace(/\D/g, "");
                if (onlyNumbers.length <= 11) {
                    this.fornecedorCPFCNPJ = null;
                    this.fornecedorCPFCNPJ = this.formatCPF(onlyNumbers);
                } 
                else if (onlyNumbers.length > 11 && onlyNumbers.length < 14) {
                    this.fornecedorCPFCNPJ = onlyNumbers;
                }
                else if (onlyNumbers.length === 14) {
                    this.fornecedorCPFCNPJ = this.formatCNPJ(onlyNumbers);
                }
            }
        },

    },

    validations: {
        fornecedor: {
            required
        },
    },

    components: {
        ModelListSelect 
    }
}
</script>
